'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = loading;

var _store = require('redux-connect/lib/store');

var _loading = require('../actions/loading');

function loading() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _loading.SET_LOADING:
    case _store.BEGIN_GLOBAL_LOAD:
      return true;
    case _loading.CLEAR_LOADING:
    case _store.END_GLOBAL_LOAD:
      return false;
    default:
      return state;
  }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/reducers/loading.js
// module id = 2532
// module chunks = 0